import React, { FC } from 'react';

import { Identity } from '~/types';
import { BlockButton, UnblockButton } from '~/components';
import { useTranslate } from 'react-admin';
import { l } from '../IdentityShow';
import { useDisableIdentity, useEnableIdentity } from '~/hooks/team';

interface Props {
  identityRecord?: Identity;
}

const ManageEnableDisable: FC<Props> = (props) => {
  const { identityRecord } = props;

  const translate = useTranslate();
  const t = (key: string): string => translate(l(key));

  const enableIdentityMutation = useEnableIdentity(identityRecord?.id);
  const disableIdentityMutation = useDisableIdentity(identityRecord?.id);

  const enableIdentity = () => {
    if (identityRecord?.id) {
      return enableIdentityMutation.mutateAsync(identityRecord?.id as any);
    }
  };
  const disableIdentity = () => {
    if (identityRecord?.id) {
      return disableIdentityMutation.mutateAsync(identityRecord?.id as any);
    }
  };

  if (identityRecord?.deleted) {
    return <UnblockButton red onClick={enableIdentity} label={t('enableIdentity')} />;
  }
  return <BlockButton red onClick={disableIdentity} label={t('disableIdentity')} />;
};

export default ManageEnableDisable;
